module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-white p-8"
  }, [(_vm.isEmpty(_vm.supplyOrders)) ? _c('div', [_vm._v("Não existem artigos no carrinho...")]) : _vm._l((_vm.supplyOrders), function(order) {
    return _c('div', {
      staticClass: "mb-12"
    }, [_c('div', {
      staticClass: "flex justify-between"
    }, [_c('h3', {
      staticClass: "text-grey-darkest flex mb-3"
    }, [_vm._v(_vm._s(order.supplier.name) + "\n        "), _c('button', {
      staticClass: "flex ml-3",
      on: {
        "click": function($event) {
          return _vm.deleteSupplyOrder(+order.id)
        }
      }
    }, [_c('icon', {
      staticClass: "w-4 text-grey hover:text-red-dark self-center",
      attrs: {
        "name": "trash-2"
      }
    })], 1)]), _vm._v(" "), _c('router-link', {
      staticClass: "self-center text-sm text-blue hover:text-blue-dark tracking-wide flex",
      attrs: {
        "to": ("/supply-orders/" + (order.id) + "/edit")
      }
    }, [_vm._v("\n        Ver\n      ")])], 1), _vm._v(" "), _c('CartProduct', {
      attrs: {
        "supplyOrderId": order.id
      }
    })], 1)
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63e85fc3","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/CartProductList.vue
// module id = 634
// module chunks = 66